export const importableColumns = {
    'contacts': {
        'first_name': {
            name: 'First Name',
            variations: ['firstname', 'first']
        },
        'last_name': {
            name: 'Last Name',
            variations: ['lastname', 'last', 'sur_name', 'surname', 'sur']
        },
        'title': {
            name: 'Title',
            variations: []
        },
        'company_name': {
            name: 'Company',
            variations: ['company', 'organization', 'org', 'business_name', 'business', 'buisness_name', 'buisness']
        },
        'birthday': {
            name: 'Birthday',
            variations: []
        },
        'anniversary': {
            name: 'Anniversary',
            variations: []
        },
        'email': {
            name: 'Email',
            variations: ['email_address', 'e_mail_address']
        },
        'alternate_email': {
            name: 'Alternate Email(s)',
            variations: ['alt_email_address', 'alt_e_mail_address', 'alternate_email_address', 'alternate_e_mail_address']
        },
        'address': {
            name: 'Address',
            variations: ['addr', 'address_1', 'address1', 'addr_1', 'adder1']
        },
        'address_2': {
            name: 'Address (cont.)',
            variations: ['address2', 'address_cont', 'address_contd', 'addr_2', 'addr2', 'addr_cont', 'addr_contd']
        },
        'city': {
            name: 'City',
            variations: []
        },
        'state_province': {
            name: 'State/Province',
            variations: ['state', 'province']
        },
        'zip_postal': {
            name: 'Zip/Postal',
            variations: ['zip', 'zipcode', 'zip_code', 'postal', 'postal_code']
        },
        'country': {
            name: 'Country',
            variations: []
        },
        /*
        'latitude': {
            name: 'Latitude',
            variations: []
        },
        'longitude': {
            name: 'Longitude',
            variations: []
        },
        */
        'home_phone': {
            name: 'Phone (Home)',
            variations: ['home', 'phone_home']
        },
        'cell_phone': {
            name: 'Phone (Cell)',
            variations: ['cell', 'mobile', 'phone_cell', 'phone_mobile', 'mobile_phone']
        },
        'work_phone': {
            name: 'Phone (Work)',
            variations: ['work', 'phone_work', 'work_phone', 'phone_business', 'business_phone']
        },
        'preferred_contact_method': {
            name: 'Preferred Contact Method',
            variations: ['preferred', 'preferred_phone']
        },
        'notes': {
            name: 'Notes',
            variations: ['note']
        },
        'is_veteran': {
            name: 'Veteran?',
            variations: ['veteran']
        },
        'is_veteran': {
            name: 'Veteran?',
            variations: ['veteran']
        },
        'is_minority': {
            name: 'Minority?',
            variations: ['minority']
        },
        'is_female': {
            name: 'Woman?',
            variations: ['female', 'woman', 'is_woman']
        },
        'is_lgbt': {
            name: 'LGBTQ?',
            variations: ['lgbtq', 'lgbt', 'gay']
        },
    },
    'businesses': {
        'name': {
            name: 'Name',
            variations: ['business_name', 'business', 'buisness_name', 'buisness', 'company', 'company_name']
        },
        'dba_name': {
            name: 'DBA',
            variations: ['dba', 'doing_business_as'],
        },
        'primary_contact_id': {
            name: 'Primary Contact',
            variations: ['owner', 'primary_contact_first_and_last', 'primary_contact']
        },
        'description': {
            name: 'Description',
            variations: ['desc']
        },
        'email': {
            name: 'Email',
            variations: ['business_email']
        },
        'phone': {
            name: 'Phone',
            variations: ['business_phone']
        },
        'fax': {
            name: 'Fax',
            variations: ['business_fax']
        },
        'url': {
            name: 'Website',
            variations: ['website']
        },
        'membership_level': {
            name: 'Membership Level',
            variations: ['membership']
        },
        'business_type': {
            name: 'Business Type',
            variations: []
        },
        'full_time': {
            name: '# Full-time Employees',
            variations: ['full_time_employees']
        },
        'part_time': {
            name: '# Part-time Employees',
            variations: ['part_time_employees', 'parttime_employees']
        },
        'seasonal': {
            name: '# Seasonal Employees',
            variations: ['seasonal_employees', 'season_employees']
        },
        /*
        // TODO: replace this with membership levels
        'is_member': {
            name: 'Is Member',
            variations: []
        },
        */
        /*
        'year_established': {
            name: 'Year Established',
            variations: []
        },
        */
        'address_mail': {
            name: 'Mailing Address',
            variations: ['addr_mailing', 'mailing_address']
        },
        'address_2_mail': {
            name: 'Mailing Address (cont.)',
            variations: ['address2_mailing', 'address_cont_mailing', 'address_contd_mailing', 'addr_2_mailing', 'addr2_mailing', 'addr_cont_mailing', 'addr_contd_mailing', 'mailing_address2', 'mailing_address_cont', 'mailing_address_contd', 'mailing_addr_2', 'mailing_addr2', 'mailing_addr_cont', 'mailing_addr_contd']
        },
        'city_mail': {
            name: 'Mailing City',
            variations: ['mailing_city']
        },
        'state_province_mail': {
            name: 'Mailing State/Province',
            variations: ['state_mailing', 'province_mailing', 'mailing_state', 'mailing_province']
        },
        'zip_postal_mail': {
            name: 'Mailing Zip/Postal',
            variations: ['zip_mailing', 'zipcode_mailing', 'zip_code_mailing', 'postal_mailing', 'postal_code_mailing', 'mailing_zip', 'mailing_zipcode', 'mailing_zip_code', 'mailing_postal', 'mailing_postal_code']
        },
        'country_mail': {
            name: 'Mailing Country',
            variations: ['mailing_country']
        },
        'facebook_url': {
            name: 'Facebook',
            variations: ['facebook']
        },
        'instagram_url': {
            name: 'Instagram',
            variations: ['instagram']
        },
        'google_plus_url': {
            name: 'Google Plus',
            variations: ['google_plus']
        },
        'twitter_url': {
            name: 'Twitter',
            variations: ['twitter']
        },
        'linkedin_url': {
            name: 'LinkedIn',
            variations: ['linkedin']
        },
        'youtube_url': {
            name: 'Youtube',
            variations: ['youtube']
        },
        'yelp_url': {
            name: 'Yelp',
            variations: ['yelp']
        },
        'not_for_profit': {
            name: 'Not for Profit',
            variations: ['not_for_profit_yes_or_no']
        },
        'not_in_district': {
            name: 'In District',
            variations: ['in_district', 'in_district_yes_or_no'],
        },
        'open_date': {
            name: 'Date Opened',
            variations: ['opened_date', 'opened_date_mm_dd_yyyy', 'opened_date_mmddyyyy']
        },
        'close_date': {
            name: 'Date Closed',
            variations: ['closed_date', 'closed_date_mm_dd_yyyy', 'closed_date_mmddyyyy']
        },
        'moved_in_date': {
            name: 'Date Relocated In',
            variations: ['moved_in', 'relocated_in_date_mm_dd_yyyy', 'relocated_in_mm_dd_yyyy', 'relocated_in_mmddyyyy', 'relocated_in_date_mmddyyyy']
        },
        'moved_out_date': {
            name: 'Date Relocated Out',
            variations: ['moved_out', 'relocated_out_date_mm_dd_yyyy', 'relocated_out_mm_dd_yyyy', 'relocated_out_mmddyyyy', 'relocated_out_date_mmddyyyy']
        },
        'tax': {
            name: 'Tax ID',
            variations: ['tax_id']
        },
        'notes': {
            name: 'Notes',
            variations: ['note']
        },
        'is_veteran': {
            name: 'Veteran-owned?',
            variations: ['veteran', 'veteran_owned', 'veteran_owned_yes_or_no']
        },
        'is_minority': {
            name: 'Minority-owned?',
            variations: ['minority', 'minority_owned', 'minority_owned_yes_or_no']
        },
        'is_female': {
            name: 'Woman-owned?',
            variations: ['female', 'woman', 'is_woman', 'female_owned', 'woman_owned', 'woman_owned_yes_or_no']
        },
        'is_lgbt': {
            name: 'LGBTQ-owned?',
            variations: ['lgbtq', 'lgbt', 'gay', 'lgbtq_owned', 'lgbt_owned', 'gay_owned', 'lgbtq_owned_yes_or_no']
        },
        // relationships (properties)
        'address': {
            name: '(Property) Address',
            variations: ['addr', 'address_1', 'address1', 'addr_1', 'adder1', 'physical_address']
        },
        'address_2': {
            name: '(Property) Address (cont.)',
            variations: ['address2', 'address_cont', 'address_contd', 'addr_2', 'addr2', 'addr_cont', 'addr_contd', 'physical_address_cont', 'physical_address_contd']
        },
        'city': {
            name: '(Property) City',
            variations: ['physical_city']
        },
        'state_province': {
            name: '(Property) State/Province',
            variations: ['state', 'province', 'physical_state']
        },
        'zip_postal': {
            name: '(Property) Zip/Postal',
            variations: ['zip', 'zipcode', 'zip_code', 'postal', 'postal_code', 'physical_zip']
        },
        'country': {
            name: '(Property) Country',
            variations: ['physical_country']
        },
    },
    'properties': {
        'address': {
            name: 'Address',
            variations: ['addr', 'address_1', 'address1', 'addr_1', 'adder1', 'property_address']
        },
        'address_2': {
            name: 'Address (cont.)',
            variations: ['address2', 'address_cont', 'address_contd', 'addr_2', 'addr2', 'addr_cont', 'addr_contd', 'property_address_cont', 'property_address_contd']
        },
        'city': {
            name: 'City',
            variations: []
        },
        'state_province': {
            name: 'State/Province',
            variations: ['state', 'province']
        },
        'zip_postal': {
            name: 'Zip/Postal',
            variations: ['zip', 'zipcode', 'zip_code', 'postal', 'postal_code']
        },
        'country': {
            name: 'Country',
            variations: []
        },
        'latitude': {
            name: 'Latitude',
            variations: []
        },
        'longitude': {
            name: 'Longitude',
            variations: []
        },
        'owner_contact': {
            name: 'Owner (Owned by Contact)',
            variations: ['owner_owned_by_contact', 'primary_contact', 'primary_contact_first_and_last']
        },
        'owner_business': {
            name: 'Owner (Owned by Business)',
            variations: ['owner_owned_by_business']
        },
        'for_lease': {
            name: 'For Lease',
            variations: ['for_lease_yes_or_no']
        },
        'for_sale': {
            name: 'For Sale',
            variations: ['for_sale_yes_or_no']
        },
        'asking_price': {
            name: 'Asking Price',
            variations: []
        },
        'assessed_market_value': {
            name: 'Assessed Market Value',
            variations: []
        },
        'square_footage': {
            name: 'Square Footage',
            variations: ['square_feet', 'squarefeet', 'sqft']
        },
        'floors': {
            name: 'Floors',
            variations: ['number_of_floors', '_of_floors']
        },
        'tif': {
            name: 'TIF',
            variations: []
        },
        'enterprise': {
            name: 'Enterprise Zone',
            variations: ['enterprise_zone', 'enterprise_zone_yes_or_no']
        },
        'ssa': {
            name: 'SSA/BID',
            variations: ['bid', 'ssabid', 'ssa_bid']
        },
        'zone': {
            name: 'Zoning',
            variations: ['zoning']
        },
        'land_use': {
            name: 'Land Use Type',
            variations: []
        },
        'parcel_number': {
            name: 'Parcel #',
            variations: ['parcel_', 'parcel_num', 'parcel_id', 'parcel']
        },
        'private_parking': {
            name: '# of Private Parking',
            variations: ['_of_private_parking_spots']
        },
        'residential_units': {
            name: '# of Residential Units',
            variations: ['residential', '_of_residential_units']
        },
        'residential_only': {
            name: 'Residential Only',
            variations: ['residential_only_yes_or_no']
        },
        'commercial_units': {
            name: '# of Commercial Units',
            variations: ['commercial', '_of_commercial_units']
        },
        'architect': {
            name: 'Architect',
            variations: []
        },
        'built_date': {
            name: 'Built Date',
            variations: ['year_built', 'date_built']
        },
        'lost': {
            name: 'Lost Date',
            variations: ['lost_date', 'lost_date_mm_dd_yyyy', 'lost_date_mmddyyyy']
        },
        'lost_reason': {
            name: 'Lost Reason',
            variations: []
        },
        'notes': {
            name: 'Notes',
            variations: ['note']
        },
        'is_veteran': {
            name: 'Veteran-owned?',
            variations: ['veteran', 'veteran_owned']
        },
        'is_minority': {
            name: 'Minority-owned?',
            variations: ['minority', 'minority_owned']
        },
        'is_female': {
            name: 'Woman-owned?',
            variations: ['female', 'woman', 'is_woman', 'female_owned', 'woman_owned']
        },
        'is_lgbt': {
            name: 'LGBTQ-owned?',
            variations: ['lgbtq', 'lgbt', 'gay', 'lgbtq_owned', 'lgbt_owned', 'gay_owned']
        },
    },
    'workplans': {
        'task_name': {
            name: 'Task Name',
            variations: ['task', 'title', 'name']
        },
        'due_date': {
            name: 'Due Date',
            variations: ['date']
        },
        'estimated_expense': {
            name: 'Expense (Estimated)',
            variations: []
        },
        'actual_expense': {
            name: 'Expense (Actual)',
            variations: []
        },
        'estimated_income': {
            name: 'Income (Estimated)',
            variations: []
        },
        'actual_income': {
            name: 'Income (Actual)',
            variations: []
        },
        'notes': {
            name: 'Notes',
            variations: ['note']
        },
    }
};
